"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkedErrorsIntegration = void 0;

var _integration = require("../integration.js");

var _aggregateErrors = require("../utils-hoist/aggregate-errors.js");

var _eventbuilder = require("../utils-hoist/eventbuilder.js");

const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;
const INTEGRATION_NAME = 'LinkedErrors';

const _linkedErrorsIntegration = (options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;
  return {
    name: INTEGRATION_NAME,

    preprocessEvent(event, hint, client) {
      const options = client.getOptions();
      (0, _aggregateErrors.applyAggregateErrorsToEvent)(_eventbuilder.exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
    }

  };
};

const linkedErrorsIntegration = exports.linkedErrorsIntegration = (0, _integration.defineIntegration)(_linkedErrorsIntegration);